import { render, staticRenderFns } from "./Vat.vue?vue&type=template&id=651e44b4&"
import script from "./Vat.vue?vue&type=script&lang=js&"
export * from "./Vat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports